import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {EntityLogo} from "../logos/entity-logo";
import styles from "./entity-carousel.module.scss";
import classnames from "classnames";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";

export class EntityCarouselItemProps extends BaseProps {
  entity: EntityViewModel;
  isSmallView: Boolean;
  isSingleItem: Boolean;
}

export const EntityCarouselItem = ({entity, isSmallView, isSingleItem}: EntityCarouselItemProps) => {
  let entityLogoSize: Number = (isSmallView ? entity?.entityLogoSize?.mobile : entity?.entityLogoSize?.desktop) || 56;

  const playerLogoProps = {
    className: classnames({[styles.single_item]: isSingleItem}),
    entity,
    width: entityLogoSize,
    height: entityLogoSize,
    eager: true
  }

  return (
    <EntityLogo {...playerLogoProps}/>
  )
}
